/**
 * Program Cards 1027 — BDU Featured Programmes
 * Heading with a gradient rule, a tab strip built from each card's "Tab" value, and a
 * wrapping row of tinted image cards with a duration pill and a "Know more" link.
 */

export const PROGRAM_CARDS_1027_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Programme cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "Online MBA",
    meta_description: "Master of Business Administration",
    meta_duration: "2 Years",
    meta_image: "",
    meta_alt_image: "",
    meta_url: "/online-mba",
    meta_category: "Masters",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Explore Our Online Programmes",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Explore Our Online Programmes",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "gradient_color_3",
      label: "Active tab gradient — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_4",
      label: "Active tab gradient — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "card_background_color",
      label: "Card tint over the image",
      value: "#222023A1",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023A1",
    },
    {
      fieldName: "cta_text",
      label: "Card link label",
      value: "Know more",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Know more",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Tab",
      fieldName: "meta_category",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Bachelors / Masters — tabs are built from these values",
      defaultValue: "",
    },
    {
      header: "Programme name",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Online MBA",
      defaultValue: "",
    },
    {
      header: "Parent programme (specialisations only)",
      fieldName: "meta_parent_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "Online MA — set this and the card shows it large with the programme name as a yellow accent",
      defaultValue: "",
    },
    {
      header: "Full name",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Master of Business Administration",
      defaultValue: "",
    },
    {
      header: "Duration",
      fieldName: "meta_duration",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "2 Years",
      defaultValue: "",
    },
    {
      header: "Card image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      header: "Card image alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Link URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/online-mba",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
